import React, { useCallback, useEffect, useRef, useState } from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap'
import reactStringReplace from 'react-string-replace'
import * as Icons from "react-feather";
import AddEnquiry from './AddEnquiry';
import EditEnquiry from './EditEnquiry';
import ViewEnquiry from './ViewEnquiry';
import DeleteEnquiry from './DeleteEnquiry';
import EnquiryModel from './models/EnquiryModel';
import LoanSummaryModal from '../../shared/finance/LoanSummaryModal'

const createEmptyEnquiryModel = () => new EnquiryModel();

function EnquiryModal({onClose, onSubmit, UserAction, show, selectedRow, moduleName}) {
    const [childData, setChildData] = useState(createEmptyEnquiryModel());
    const [loanSummary, setLoanSummary] = useState(null);
    const [showLoanSummary, setShowLoanSummary] = useState(false);
    const loanSummaryApplyRef = useRef(null);
    let modalAction;
    let showButtons;
    let userAction = reactStringReplace(UserAction, 'User', () => '');

    useEffect(() => {
        if (show && selectedRow) {
          setChildData({ ...selectedRow }); // create a new object to break reference
        } else if (!show) {
                    setChildData(createEmptyEnquiryModel()); // reset when closed
        }
    }, [selectedRow, show]);

    const handleDataFromChild = useCallback((data) => {
        setChildData(data);
    }, []);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(e, childData);  // Send the form data back to the parent component
    };

    const handleLoad = useCallback((data) => {
        setChildData(data); // Send the form data back to the parent component
    }, []);

    const handleLoanSummaryRequest = useCallback((summary) => {
        setLoanSummary(summary);
        setShowLoanSummary(true);
    }, []);

    const closeLoanSummaryModal = useCallback(() => {
        setShowLoanSummary(false);
        if (loanSummary && typeof loanSummaryApplyRef.current === 'function') {
            loanSummaryApplyRef.current(loanSummary);
        }
    }, [loanSummary]);
    if(UserAction === "Add"){
        modalAction = (
            <AddEnquiry
                onLoad={handleLoad}
                sendDataToParent={handleDataFromChild}
                onLoanSummary={handleLoanSummaryRequest}
                onRegisterLoanSummaryApply={(fn) => { loanSummaryApplyRef.current = fn; }}
            />
        );
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="Add" onClick={onClose}>Cancel</button>
                            <button className="btn btn-submit" name="Add" onClick={handleSubmit}> Submit </button>
                    </div>
    } else if(UserAction === "Edit"){
        modalAction = (
            <EditEnquiry
                selectedRow={selectedRow}
                sendDataToParent={handleDataFromChild}
                onLoanSummary={handleLoanSummaryRequest}
                onRegisterLoanSummaryApply={(fn) => { loanSummaryApplyRef.current = fn; }}
            />
        );
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="Edit" onClick={onClose}>Cancel</button>
                            <button className="btn btn-submit" name="Edit" onClick={handleSubmit}> Submit </button>
                    </div>
    } else if(UserAction === "View"){
        modalAction = <ViewEnquiry selectedRow={selectedRow}/>
        showButtons = <div>
                            <button className="btn btn-cancel me-2" name="View" onClick={onClose}>Cancel</button>
                    </div>
    } else if(UserAction === "Delete"){
        modalAction = <DeleteEnquiry selectedRow={selectedRow}/>
        showButtons = <div>
                            <button className="btn btn-sm btn-secondary m-1" name="Delete" onClick={onClose}>Cancel</button>
                            <button className="btn btn-sm btn-danger m-1" name="Delete" onClick={handleSubmit}>Delete</button>
                    </div>
    }
    return (
        <>
            {UserAction !== "Delete" ? (
                <Modal
                    show={show}
                    onHide={onClose}
                    backdrop="static"
                    dialogClassName="add-centered"
                >
                    <ModalHeader className="modal-header border-0 custom-modal-header" closeButton>
                        <ModalTitle>{userAction + " " + moduleName}</ModalTitle>
                    </ModalHeader>
                    <ModalBody>{modalAction}</ModalBody>
                    <ModalFooter>{showButtons}</ModalFooter>
                </Modal>
            ) : (
                <Modal
                    show={show}
                    onHide={onClose}
                    backdrop="static"
                >
                    <ModalHeader className="alert custom-alert1 alert-danger modalheader-width">
                        <ModalTitle>
                            <div className="custom-alert-icon">
                                <Icons.AlertOctagon className="flex-shrink-0" />
                            </div>
                            <div> {userAction} {moduleName}</div>
                        </ModalTitle>
                    </ModalHeader>

                    <ModalBody>{modalAction}</ModalBody>
                    <ModalFooter className="modalfooter-width">{showButtons}</ModalFooter>
                </Modal>
            )}
            <LoanSummaryModal show={showLoanSummary} onClose={closeLoanSummaryModal} summary={loanSummary} />
        </>
    )
}

export default EnquiryModal
